
export class ExportImgManager {

  static getEncodedImage(canvas: HTMLCanvasElement, kind: 'png' | 'jpeg' = 'png'): string {
    return  canvas.toDataURL(`image/${kind}`);
  }

}
